import { ReactNode } from "react";

export default function Table({
   columns,
   data,
   components,
   title,
   loading,
   onExport,
   exporting,
}: {
   columns: { label?: string; name: string; render?: any }[];
   data: any[];
   title?: string | ReactNode | JSX.Element;
   components?: {
      toolbar: any;
   };
   loading?: boolean;
   onExport?: () => void | Promise<void>;
   exporting?: boolean;
}) {
   const showHeader = title || onExport || components?.toolbar;
   return (
      <>
         {showHeader && (
            <div className='toolbar flex justify-between px-2 py-2 items-center gap-10'>
               <h3 className='capitalize'>{title}</h3>
               <div className='flex items-center gap-2'>
                  {onExport && (
                     <button
                        type='button'
                        onClick={() => onExport()}
                        disabled={exporting || !data || data.length === 0}
                        className='bg-emerald-600 hover:bg-emerald-700 disabled:bg-gray-300 px-2 py-1 text-white border rounded text-sm'
                        title='Export currently filtered rows to Excel'
                     >
                        {exporting ? "Exporting..." : "Export to Excel"}
                     </button>
                  )}
                  {components?.toolbar ? <components.toolbar /> : null}
               </div>
            </div>
         )}
         <div className='p-2 table-wrap'>
            <table className='table border-collapse border border-slate-400 table-auto w-full text-left text-xs'>
               <thead className='bg-slate-100'>
                  <tr>
                     {columns.map((col, idx) => (
                        <th key={idx} className='border border-slate-300 px-2'>
                           {col.label}
                        </th>
                     ))}
                  </tr>
               </thead>
               <tbody>
                  {data?.map((i: any, idx0) => {
                     let total = columns.find((c) => {
                        if (c.render) return false;
                        let val = i[c.name];
                        return val === "Total";
                     });
                     return (
                        <tr key={idx0} className={`row-${total ? "total" : "normal"}`}>
                           {columns.map((col, idx) => {
                              if (idx === 0) {
                                 let val = i[col.name];
                                 return (
                                    <td key={idx} className='border border-slate-300 px-2' data-row={`${val}`}>
                                       {val}
                                    </td>
                                 );
                              }
                              if (!col.render) {
                                 return (
                                    <td key={idx} className='border border-slate-300 px-2'>
                                       {i[col.name]}
                                    </td>
                                 );
                              }

                              return (
                                 <td key={idx} className='border border-slate-300 px-2'>
                                    <col.render row={i} />
                                 </td>
                              );
                           })}
                        </tr>
                     );
                  })}
               </tbody>
            </table>
            {loading ? (
               <p className='px-2 text-orange-400'>Loading ...</p>
            ) : !data ? (
               <p className='px-2'>No data found</p>
            ) : null}
         </div>
      </>
   );
}
